import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/report-management/top-customer-report`;

export const topCustomerReportRoutesObj = {
  list: baseRoute,
  // TODO: ADD VIEW INVOICE AND DEBT PAYMENT PAGES LATER
} as const;

export type ITopCustomerReportRouteParams = IExtractRouteParamMap<
  typeof topCustomerReportRoutesObj
>;

export const topCustomerReportPath = createPaths<
  typeof topCustomerReportRoutesObj,
  ITopCustomerReportRouteParams
>(topCustomerReportRoutesObj);
